import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import LandingPage from "./pages/LandingPage";
import ImpactPage from "./pages/ImpactPage";
import LearnMorePage from "./pages/LearnMorePage";

function App() {
  const merchantCode = 'SHO_CA_ELA_HANDBAGS';
  const [fetchedImpact, setfetchedImpact] = useState();
  const [projects, setProjects] = useState();

 {/*} useEffect(() => {

    if (!location?.pathname.includes('impact')) { // fetch impact projects
      project.projects(null, merchantCode, null)
        .then(response => response.json())
        .then(body => setProjects(body))
        .catch(error => {
          console.error(error);
          setProjects(error);
        })
    }

    impact.merchants(merchantCode, null, ['flightsImpact']) // fetch flight impact
      .then(response => response.json())
      .then(body => {
        setfetchedImpact(body)
      })
      .catch(error => {
        console.error(error);
        setfetchedImpact(error)
      })
  }, []);*/}

  return (
    <>

      <Switch>
        <Route
          path={`/`}
          key="app-ELA-landing"
        >
          <LandingPage fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
      </Switch>

    </>
  );
}

export default App;
